module.exports = __webpack_public_path__ + "img/gana_gana.6b0b18b.png";